import React, { useState, useEffect } from 'react';
import type { MenuProps } from 'antd';
import { Menu, Button } from 'antd';
import type { SelectInfo } from 'rc-menu/lib/interface';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { UserInfo } from '@/models/perms_type';
import styles from './index.module.less';

type MenuItem = Required<MenuProps>['items'][number];

interface ProductNavMenuProps {
    userInfo: UserInfo;
    collapsed: boolean;
    productNavMenu: MenuItem[];
    onCollapse: (collapsed: boolean) => void;
    handleJumpTo: (path: string) => void;
    activeMenu: string;
    pathname: string;
}

const ProductNavMenu: React.FC<ProductNavMenuProps> = ({
    userInfo,
    collapsed,
    onCollapse,
    handleJumpTo,
    activeMenu,
    productNavMenu,
    pathname
}) => {
    const [openKeys, setOpenKeys] = useState<string[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    useEffect(() => {
        // 查找包含当前路径的父菜单（子路径匹配）
        const parentByChild = productNavMenu.find(item => {
            if (item && 'children' in item && item.children) {
                return item.children.some(child => child && child.key === pathname);
            }
            return false;
        });
        
        // 查找直接匹配的父菜单（父路径匹配）
        // 父菜单的 key 可能是 /resource，而 pathname 是 /taxi/resource
        // 需要同时支持两种情况
        const parentByKey = productNavMenu.find(item => {
            if (item && 'children' in item) {
                const itemKey = item.key as string;
                // 检查是否精确匹配或添加 /taxi 后匹配
                return pathname === itemKey || pathname === `/taxi${itemKey}`;
            }
            return false;
        });
        const matchedParent = parentByChild || parentByKey;
        if (matchedParent && matchedParent.key) {
            setOpenKeys([matchedParent.key as string]);
            if (parentByChild) {
                // 有子路径匹配，选中该子项
                setSelectedKeys([pathname]);
            } else {
                // 只有父路径匹配，不选中子项
                setSelectedKeys([]);
            }
        } else {
            setOpenKeys([]);
            setSelectedKeys([]);
        }
    }, [pathname, productNavMenu]);

    const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
        setOpenKeys(keys);
    };

    const handleCollapse = () => {
        onCollapse(!collapsed);
    };

    const handleMenuSelect = (info: SelectInfo) => {
        // if (info.key === '/taxi/order/vehicles' || info.key === '/taxi/odd/point') {
        //     window.location.assign(info.key);
        //     return;
        // }

        handleJumpTo(info.key);
    };

    return (
        <div className={`${styles.navMenu} ${collapsed ? styles.navMenuCollapsed : ''}`}>
            <Menu
                inlineCollapsed={collapsed}
                mode="inline"
                items={productNavMenu}
                onSelect={handleMenuSelect}
                className={styles.menu}
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                
            />
            <div className={styles.divider}></div>
            <div className={styles.collapseButton}>
                <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={handleCollapse}
                    className={styles.collapseBtn}
                />
            </div>
        </div>
    );
};

export default ProductNavMenu;
